import React from 'react'

const SubmittedPerformanceIndex = ({ active, count }) => {
    return (
        <div>
            {active === 0 && (
                <>
                    <h5 className="centertext my-5">
                        ACADEMIC CONTRIBUTIONS
                    </h5>
                    <table className="tablereport table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Topic</th>
                                <th scope="col">Criteria</th>
                                <th scope="col">Target Fixed</th>
                                <th scope="col">Score/Item</th>
                                <th scope="col">Score Fixed</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="tablewidth">
                                    a. Grant in aid Training Programmes conducted
                                    as Coordinator Training programmes conducted for 3
                                    days as 0.5 equivalence and "n" weeks as "n"
                                    equivalence of 5 days Conduct of number of 5 days
                                    training programmes 20, 18 and 16 for Assistant
                                    Professor, Associate Professor and Professor
                                    respectively. Revenue Generated through Training Programmes as Co-ordinator
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            Training Programmes conducted as Coordinator
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            Additional training programmes conducted as
                                            Coordinator
                                        </td>
                                    </tr>
                                    <br />

                                    <tr>
                                        <td>
                                            &lt; 3 lakhs
                                        </td>
                                    </tr>
                                    <br />

                                    <tr>
                                        <td>
                                            3-5 lakhs
                                        </td>
                                    </tr>
                                    <br />

                                    <tr>
                                        <td>
                                            &gt; 5 lakhs
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.non_sponsored_training?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.training_programmes_conducted?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.aid_training_programmes_lt_3_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.aid_training_programmes_3_t0_5_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.aid_training_programmes_gt_5_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.non_sponsored_training?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.training_programmes_conducted?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.aid_training_programmes_lt_3_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.aid_training_programmes_3_t0_5_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.aid_training_programmes_gt_5_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.non_sponsored_training?.total_activity *
                                                count?.academic_contributions
                                                    ?.non_sponsored_training?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.training_programmes_conducted?.total_activity *
                                                count?.academic_contributions
                                                    ?.training_programmes_conducted?.per_actitity_score || '-'}{" "}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.aid_training_programmes_lt_3_lakhs?.total_activity *
                                                count?.academic_contributions
                                                    ?.aid_training_programmes_lt_3_lakhs?.per_actitity_score || '-'}{" "}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.aid_training_programmes_3_t0_5_lakhs?.total_activity *
                                                count?.academic_contributions
                                                    ?.aid_training_programmes_3_t0_5_lakhs?.per_actitity_score || '-'}{" "}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.aid_training_programmes_gt_5_lakhs?.total_activity *
                                                count?.academic_contributions
                                                    ?.aid_training_programmes_gt_5_lakhs?.per_actitity_score || '-'}{" "}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    b. Sponsored Training Programmes
                                    conducted as Coordinator/ Co-coordinator (Funded by State/ Central Government or ITEC)
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            Training programmes conducted as Coordinator
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            Training programmes conducted as
                                            Co-coordinator
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions?.sponsored_contact_mode_for_coordinator_training?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions?.sponsored_contact_mode_for_co_coordinator_training?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions?.sponsored_contact_mode_for_coordinator_training?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions?.sponsored_contact_mode_for_co_coordinator_training?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.sponsored_contact_mode_for_coordinator_training?.total_activity *
                                                count?.academic_contributions
                                                    ?.sponsored_contact_mode_for_coordinator_training?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.sponsored_contact_mode_for_co_coordinator_training?.total_activity *
                                                count?.academic_contributions
                                                    ?.sponsored_contact_mode_for_co_coordinator_training?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    c. Skill Development/ Industrial Training
                                    Programmes conducted as Coordinator/
                                    Co-coordinator
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            Training programmes conducted as Coordinator
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            Training programmes conducted as
                                            Co-coordinator
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.skill_development_for_coordinator_training?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.skill_development_for_co_coordinator_training?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.skill_development_for_coordinator_training?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.skill_development_for_co_coordinator_training?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.skill_development_for_coordinator_training?.total_activity *
                                                count?.academic_contributions
                                                    ?.skill_development_for_coordinator_training?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.skill_development_for_co_coordinator_training?.total_activity *
                                                count?.academic_contributions
                                                    ?.skill_development_for_co_coordinator_training?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    d. Development/ offer of MOOCs/ MMLPs as Coordinator/
                                    Co-coordinator or minimum 30 min video lectures/
                                    Educational video films
                                </td>
                                <td>
                                    <tr>
                                        <td>Offering of SWAYAM Course/ NITTT module</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            Development of minimum 30 min video lecture/
                                            Educational video films
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.development_of_moocs_offering_swayam_courses_or_nittt_module?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.development_for_minimum_30_min_video?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.development_of_moocs_offering_swayam_courses_or_nittt_module?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.development_for_minimum_30_min_video?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.development_of_moocs_offering_swayam_courses_or_nittt_module?.total_activity *
                                                count?.academic_contributions
                                                    ?.development_of_moocs_offering_swayam_courses_or_nittt_module?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.development_for_minimum_30_min_video?.total_activity *
                                                count?.academic_contributions
                                                    ?.development_for_minimum_30_min_video?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    e. Resource person in Training Programmes
                                    (Institute)
                                </td>
                                <td>For 18 hours</td>
                                <td>
                                    {
                                        count?.academic_contributions
                                            ?.resouce_program_in_training_programmes?.total_activity || '-'
                                    }
                                </td>
                                <td>
                                    {
                                        count?.academic_contributions
                                            ?.resouce_program_in_training_programmes?.per_actitity_score || '-'
                                    }
                                </td>
                                <td>
                                    {count?.academic_contributions
                                        ?.resouce_program_in_training_programmes?.total_activity *
                                        count?.academic_contributions
                                            ?.resouce_program_in_training_programmes?.per_actitity_score || '-'}
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    f. Development of Training/ Laboratory Manuals
                                </td>
                                <td>
                                    Development of Training/ Laboratory Manuals
                                </td>
                                <td>
                                    {
                                        count?.academic_contributions
                                            ?.development_of_training_manual?.total_activity || '-'
                                    }
                                </td>
                                <td>
                                    {
                                        count?.academic_contributions
                                            ?.development_of_training_manual?.per_actitity_score || '-'
                                    }
                                </td>
                                <td>
                                    {count?.academic_contributions
                                        ?.development_of_training_manual?.total_activity *
                                        count?.academic_contributions
                                            ?.development_of_training_manual?.per_actitity_score || '-'}
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    g. Courses handled for PG/ Ph.D. programme
                                </td>
                                <td>
                                    Classes handled individually for a 3 credit course/ semester
                                    (If classes were conducted jointly, then the score will
                                    be considered proportionately based on the number of faculty members involved)
                                </td>
                                <td>
                                    {
                                        count?.academic_contributions
                                            ?.coursed_handled_for_pg_phd_programme?.total_activity || '-'
                                    }
                                </td>
                                <td>
                                    {
                                        count?.academic_contributions
                                            ?.coursed_handled_for_pg_phd_programme?.per_actitity_score || '-'
                                    }
                                </td>
                                <td>
                                    {count?.academic_contributions
                                        ?.coursed_handled_for_pg_phd_programme?.total_activity *
                                        count?.academic_contributions
                                            ?.coursed_handled_for_pg_phd_programme?.per_actitity_score || '-'}
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    h. New course(s) developed and offered
                                </td>
                                <td>3 credit course or its equivalent</td>
                                <td>
                                    {
                                        count?.academic_contributions
                                            ?.new_courses_developed_and_offered?.total_activity || '-'
                                    }
                                </td>
                                <td>
                                    {
                                        count?.academic_contributions
                                            ?.new_courses_developed_and_offered?.per_actitity_score || '-'
                                    }
                                </td>
                                <td>
                                    {count?.academic_contributions
                                        ?.new_courses_developed_and_offered?.total_activity *
                                        count?.academic_contributions
                                            ?.new_courses_developed_and_offered?.per_actitity_score || '-'}
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    i. Curriculum Developed/ Revised
                                </td>
                                <td>
                                    <tr>
                                        <td>&lt; 3 lakhs</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>3 - 5 lakhs</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>5 - 10 lakhs</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>10 - 15 lakhs</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>&gt; 15 lakhs</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_lt_3_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_3_to_5_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_5_to_10_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_10_to_15_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_gt_15_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_lt_3_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_3_to_5_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_5_to_10_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_10_to_15_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_gt_15_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.curriculum_developed_revised_lt_3_lakhs?.total_activity *
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_lt_3_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.curriculum_developed_revised_3_to_5_lakhs?.total_activity *
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_3_to_5_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.curriculum_developed_revised_5_to_10_lakhs?.total_activity *
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_5_to_10_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.curriculum_developed_revised_10_to_15_lakhs?.total_activity *
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_10_to_15_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.academic_contributions
                                                ?.curriculum_developed_revised_gt_15_lakhs?.total_activity *
                                                count?.academic_contributions
                                                    ?.curriculum_developed_revised_gt_15_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">Total</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    {
                                        count?.academic_contributions
                                            ?.non_sponsored_training?.total_activity *
                                        count?.academic_contributions
                                            ?.non_sponsored_training?.per_actitity_score +

                                        count?.academic_contributions
                                            ?.aid_training_programmes_3_t0_5_lakhs?.total_activity *
                                        count?.academic_contributions
                                            ?.aid_training_programmes_3_t0_5_lakhs?.per_actitity_score +

                                        count?.academic_contributions
                                            ?.aid_training_programmes_gt_5_lakhs?.total_activity *
                                        count?.academic_contributions
                                            ?.aid_training_programmes_gt_5_lakhs?.per_actitity_score +

                                        count?.academic_contributions
                                            ?.aid_training_programmes_lt_3_lakhs?.total_activity *
                                        count?.academic_contributions
                                            ?.aid_training_programmes_lt_3_lakhs?.per_actitity_score +


                                        count?.academic_contributions
                                            ?.training_programmes_conducted?.total_activity *
                                        count?.academic_contributions
                                            ?.training_programmes_conducted?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.sponsored_contact_mode_for_coordinator_training?.total_activity *
                                        count?.academic_contributions
                                            ?.sponsored_contact_mode_for_coordinator_training?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.sponsored_contact_mode_for_co_coordinator_training?.total_activity *
                                        count?.academic_contributions
                                            ?.sponsored_contact_mode_for_co_coordinator_training?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.skill_development_for_coordinator_training?.total_activity *
                                        count?.academic_contributions
                                            ?.skill_development_for_coordinator_training?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.skill_development_for_co_coordinator_training?.total_activity *
                                        count?.academic_contributions
                                            ?.skill_development_for_co_coordinator_training?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.development_of_moocs_offering_swayam_courses_or_nittt_module?.total_activity *
                                        count?.academic_contributions
                                            ?.development_of_moocs_offering_swayam_courses_or_nittt_module?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.development_for_minimum_30_min_video?.total_activity *
                                        count?.academic_contributions
                                            ?.development_for_minimum_30_min_video?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.resouce_program_in_training_programmes?.total_activity *
                                        count?.academic_contributions
                                            ?.resouce_program_in_training_programmes?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.development_of_training_manual?.total_activity *
                                        count?.academic_contributions
                                            ?.development_of_training_manual?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.coursed_handled_for_pg_phd_programme?.total_activity *
                                        count?.academic_contributions
                                            ?.coursed_handled_for_pg_phd_programme?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.new_courses_developed_and_offered?.total_activity *
                                        count?.academic_contributions
                                            ?.new_courses_developed_and_offered?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.curriculum_developed_revised_lt_3_lakhs?.total_activity *
                                        count?.academic_contributions
                                            ?.curriculum_developed_revised_lt_3_lakhs?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.curriculum_developed_revised_3_to_5_lakhs?.total_activity *
                                        count?.academic_contributions
                                            ?.curriculum_developed_revised_3_to_5_lakhs?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.curriculum_developed_revised_5_to_10_lakhs?.total_activity *
                                        count?.academic_contributions
                                            ?.curriculum_developed_revised_5_to_10_lakhs?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.curriculum_developed_revised_10_to_15_lakhs?.total_activity *
                                        count?.academic_contributions
                                            ?.curriculum_developed_revised_10_to_15_lakhs?.per_actitity_score +
                                        count?.academic_contributions
                                            ?.curriculum_developed_revised_gt_15_lakhs?.total_activity *
                                        count?.academic_contributions
                                            ?.curriculum_developed_revised_gt_15_lakhs?.per_actitity_score}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )}
            {active === 1 && (
                <>
                    <h5 className="centertext my-5">
                        RESEARCH CONTRIBUTIONS
                    </h5>
                    <table className="tablereport table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Topic</th>
                                <th scope="col">Criteria</th>
                                <th scope="col">Target Fixed	</th>
                                <th scope="col">Score/Item	</th>
                                <th scope="col">Score Fixed</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="tablewidth">
                                    a. Ph.D. research scholars guided
                                </td>
                                <td>Degree awarded</td>
                                <td>
                                    {
                                        count?.research_contributions
                                            ?.phd_research_guidance?.total_activity || '-'
                                    }
                                </td>
                                <td>
                                    {
                                        count?.research_contributions
                                            ?.phd_research_guidance?.per_actitity_score || '-'
                                    }
                                </td>
                                <td>
                                    {count?.research_contributions
                                        ?.phd_research_guidance?.total_activity *
                                        count?.research_contributions
                                            ?.phd_research_guidance?.per_actitity_score || '-'}
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    b. Post Graduate thesis guided
                                </td>
                                <td>Degree awarded</td>
                                <td>
                                    {
                                        count?.research_contributions
                                            ?.post_graduate_thesis_guidance?.total_activity || '-'
                                    }
                                </td>
                                <td>
                                    {
                                        count?.research_contributions
                                            ?.post_graduate_thesis_guidance?.per_actitity_score || '-'
                                    }
                                </td>
                                <td>
                                    {count?.research_contributions
                                        ?.post_graduate_thesis_guidance?.total_activity *
                                        count?.research_contributions
                                            ?.post_graduate_thesis_guidance?.per_actitity_score || '-'}
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    c. Sponsored research projects carried out
                                </td>
                                <td>
                                    <tr>
                                        <td>Submitted</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>&lt; 5 lakhs</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>5 - 15 lakhs</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>&gt; 15 lakhs</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_submitted?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_lt_5_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_5_to_15_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_gt_15_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_submitted?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_lt_5_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_5_to_15_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_gt_15_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.sponsored_research_projects_submitted?.total_activity *
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_submitted?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.sponsored_research_projects_lt_5_lakhs?.total_activity *
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_lt_5_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.sponsored_research_projects_5_to_15_lakhs?.total_activity *
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_5_to_15_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.sponsored_research_projects_gt_15_lakhs?.total_activity *
                                                count?.research_contributions
                                                    ?.sponsored_research_projects_gt_15_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    d. Consultancy works carried out based on the requirements of the Clientele system.
                                </td>
                                <td>
                                    <tr>
                                        <td>&lt; 3 lakhs</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>3 - 5 lakhs</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>&gt; 5 lakhs</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.consultancy_works_carried_out_lt_3_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.consultancy_works_carried_out_3_to_5_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.consultancy_works_carried_out_gt_5_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.consultancy_works_carried_out_lt_3_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.consultancy_works_carried_out_3_to_5_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.consultancy_works_carried_out_gt_5_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.consultancy_works_carried_out_lt_3_lakhs?.total_activity *
                                                count?.research_contributions
                                                    ?.consultancy_works_carried_out_lt_3_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.consultancy_works_carried_out_3_to_5_lakhs?.total_activity *
                                                count?.research_contributions
                                                    ?.consultancy_works_carried_out_3_to_5_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.consultancy_works_carried_out_gt_5_lakhs?.total_activity *
                                                count?.research_contributions
                                                    ?.consultancy_works_carried_out_gt_5_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    e. Research publications in referred
                                    journals only as first/ corresponding
                                    author (For more than one author, the
                                    score for other authors will be 50%)
                                </td>
                                <td>
                                    <tr>
                                        <td>SCI</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Scopus indexed</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>UGC listed</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.research_publications_in_sci?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.research_publications_in_scopus_indexed?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.research_publications_in_ugc_listed?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.research_publications_in_sci?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.research_publications_in_scopus_indexed?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.research_publications_in_ugc_listed?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.research_publications_in_sci?.total_activity *
                                                count?.research_contributions
                                                    ?.research_publications_in_sci?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.research_publications_in_scopus_indexed?.total_activity *
                                                count?.research_contributions
                                                    ?.research_publications_in_scopus_indexed?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.research_publications_in_ugc_listed?.total_activity *
                                                count?.research_contributions
                                                    ?.research_publications_in_ugc_listed?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    f. Papers presented in national/ international
                                    conference/ seminar
                                </td>
                                <td>
                                    <tr>
                                        <td>International</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>National</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.paper_presented_in_international?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.paper_presented_in_national?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.paper_presented_in_international?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.paper_presented_in_national?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.paper_presented_in_international?.total_activity *
                                                count?.research_contributions
                                                    ?.paper_presented_in_international?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.paper_presented_in_national?.total_activity *
                                                count?.research_contributions
                                                    ?.paper_presented_in_national?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    g. Books Authored/ Edited book/ edited
                                    proceedings/ book chapter/ monographs (only with
                                    ISBN/ ISSN) (as first author, for more than one
                                    author, the score for other authors
                                    will be 50%)
                                </td>
                                <td>
                                    <tr>
                                        <td>Books - International Publisher</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Books - National Publisher</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Book Chapter - International Publisher</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Book Chapter - National Publisher</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.books_international_publisher?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.books_national_publisher?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.book_chapter_international_publisher?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.book_chapter_national_publisher?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.books_international_publisher?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.books_national_publisher?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.book_chapter_international_publisher?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.book_chapter_national_publisher?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.books_international_publisher?.total_activity *
                                                count?.research_contributions
                                                    ?.books_international_publisher?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.books_national_publisher?.total_activity *
                                                count?.research_contributions
                                                    ?.books_national_publisher?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.book_chapter_international_publisher?.total_activity *
                                                count?.research_contributions
                                                    ?.book_chapter_international_publisher?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.book_chapter_national_publisher?.total_activity *
                                                count?.research_contributions
                                                    ?.book_chapter_national_publisher?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    h. Patents, copy right and technology transfer
                                    agreements signed
                                </td>
                                <td>
                                    <tr>
                                        <td>Granted - International</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Granted - National</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Published - International</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Published - National</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.patents_granted_international?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions?.patents_granted?.total_activity || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions?.patents_filed_international?.total_activity || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions?.patents_filed?.total_activity || '-'}
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.patents_granted_international?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions?.patents_granted?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions?.patents_filed_international?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions?.patents_filed?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.patents_granted_international?.total_activity *
                                                count?.research_contributions
                                                    ?.patents_granted_international?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.patents_granted?.total_activity *
                                                count?.research_contributions
                                                    ?.patents_granted?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.patents_filed_international?.total_activity *
                                                count?.research_contributions
                                                    ?.patents_filed_international?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.patents_filed?.total_activity *
                                                count?.research_contributions
                                                    ?.patents_filed?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    i. Honors/ awards/ medals/ fellowships for
                                    outstanding contributions
                                </td>
                                <td>
                                    <tr>
                                        <td>International</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>National</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.international_awards?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.national_awards?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.international_awards?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.research_contributions
                                                    ?.national_awards?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.international_awards?.total_activity *
                                                count?.research_contributions
                                                    ?.international_awards?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.research_contributions
                                                ?.national_awards?.total_activity *
                                                count?.research_contributions
                                                    ?.national_awards?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">Total</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    {count?.research_contributions
                                        ?.phd_research_guidance?.total_activity *
                                        count?.research_contributions
                                            ?.phd_research_guidance?.per_actitity_score +
                                        count?.research_contributions
                                            ?.post_graduate_thesis_guidance?.total_activity *
                                        count?.research_contributions
                                            ?.post_graduate_thesis_guidance?.per_actitity_score +
                                        count?.research_contributions
                                            ?.sponsored_research_projects_submitted?.total_activity *
                                        count?.research_contributions
                                            ?.sponsored_research_projects_submitted?.per_actitity_score +
                                        count?.research_contributions
                                            ?.sponsored_research_projects_lt_5_lakhs?.total_activity *
                                        count?.research_contributions
                                            ?.sponsored_research_projects_lt_5_lakhs?.per_actitity_score +
                                        count?.research_contributions
                                            ?.sponsored_research_projects_5_to_15_lakhs?.total_activity *
                                        count?.research_contributions
                                            ?.sponsored_research_projects_5_to_15_lakhs?.per_actitity_score +
                                        count?.research_contributions
                                            ?.sponsored_research_projects_gt_15_lakhs?.total_activity *
                                        count?.research_contributions
                                            ?.sponsored_research_projects_gt_15_lakhs?.per_actitity_score +
                                        count?.research_contributions
                                            ?.consultancy_works_carried_out_lt_3_lakhs?.total_activity *
                                        count?.research_contributions
                                            ?.consultancy_works_carried_out_lt_3_lakhs?.per_actitity_score +
                                        count?.research_contributions
                                            ?.consultancy_works_carried_out_3_to_5_lakhs?.total_activity *
                                        count?.research_contributions
                                            ?.consultancy_works_carried_out_3_to_5_lakhs?.per_actitity_score +
                                        count?.research_contributions
                                            ?.consultancy_works_carried_out_gt_5_lakhs?.total_activity *
                                        count?.research_contributions
                                            ?.consultancy_works_carried_out_gt_5_lakhs?.per_actitity_score +
                                        count?.research_contributions
                                            ?.research_publications_in_sci?.total_activity *
                                        count?.research_contributions
                                            ?.research_publications_in_sci?.per_actitity_score +
                                        count?.research_contributions
                                            ?.research_publications_in_scopus_indexed?.total_activity *
                                        count?.research_contributions
                                            ?.research_publications_in_scopus_indexed?.per_actitity_score +
                                        count?.research_contributions
                                            ?.research_publications_in_ugc_listed?.total_activity *
                                        count?.research_contributions
                                            ?.research_publications_in_ugc_listed?.per_actitity_score +
                                        count?.research_contributions
                                            ?.paper_presented_in_international?.total_activity *
                                        count?.research_contributions
                                            ?.paper_presented_in_international?.per_actitity_score +
                                        count?.research_contributions
                                            ?.paper_presented_in_national?.total_activity *
                                        count?.research_contributions
                                            ?.paper_presented_in_national?.per_actitity_score +
                                        count?.research_contributions
                                            ?.books_international_publisher?.total_activity *
                                        count?.research_contributions
                                            ?.books_international_publisher?.per_actitity_score +
                                        count?.research_contributions
                                            ?.books_national_publisher?.total_activity *
                                        count?.research_contributions
                                            ?.books_national_publisher?.per_actitity_score +
                                        count?.research_contributions
                                            ?.book_chapter_international_publisher?.total_activity *
                                        count?.research_contributions
                                            ?.book_chapter_international_publisher?.per_actitity_score +
                                        count?.research_contributions
                                            ?.book_chapter_national_publisher?.total_activity *
                                        count?.research_contributions
                                            ?.book_chapter_national_publisher?.per_actitity_score +
                                        count?.research_contributions?.patents_granted?.total_activity *
                                        count?.research_contributions?.patents_granted?.per_actitity_score +
                                        count?.research_contributions?.patents_filed?.total_activity *
                                        count?.research_contributions?.patents_filed?.per_actitity_score +
                                        count?.research_contributions?.patents_granted_international?.total_activity *
                                        count?.research_contributions?.patents_granted_international?.per_actitity_score +
                                        count?.research_contributions?.patents_filed_international?.total_activity *
                                        count?.research_contributions?.patents_filed_international?.per_actitity_score +
                                        count?.research_contributions
                                            ?.international_awards?.total_activity *
                                        count?.research_contributions
                                            ?.international_awards?.per_actitity_score +
                                        count?.research_contributions?.national_awards?.total_activity *
                                        count?.research_contributions
                                            ?.national_awards?.per_actitity_score}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )}
            {active === 2 && (
                <>
                    <h5 className="centertext my-5">
                        INSTITUTIONAL DEVELOPMENT
                    </h5>
                    <table className="tablereport table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Topic</th>
                                <th scope="col">Criteria</th>
                                <th scope="col">Target Fixed	</th>
                                <th scope="col">Score/Item	</th>
                                <th scope="col">Score Fixed</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="tablewidth">
                                    a. Administrative contributions (subject to the
                                    conduct of atleast two meetings in 6 months)
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            HOD/ In charge/ Chairman of the Committee
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Member of Committee</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.administrative_contributions_hod_of_the_committee?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.administrative_contributions_member_of_the_committee?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.administrative_contributions_hod_of_the_committee?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.administrative_contributions_member_of_the_committee?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.institutional_development
                                                ?.administrative_contributions_hod_of_the_committee?.total_activity *
                                                count?.institutional_development
                                                    ?.administrative_contributions_hod_of_the_committee?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.institutional_development
                                                ?.administrative_contributions_member_of_the_committee?.total_activity *
                                                count?.institutional_development
                                                    ?.administrative_contributions_member_of_the_committee?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    b. Infrastructure developed with internal/
                                    external funding for improvement in science and
                                    technology
                                </td>
                                <td>
                                    <tr>
                                        <td>Internal Funding more than 10 lakhs</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>External Funding upto 5 lakhs</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.infrastructure_development_internal_funding_upto_10_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.infrastructure_development_external_funding_upto_5_lakhs?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.infrastructure_development_internal_funding_upto_10_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.infrastructure_development_external_funding_upto_5_lakhs?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.institutional_development
                                                ?.infrastructure_development_internal_funding_upto_10_lakhs?.total_activity *
                                                count?.institutional_development
                                                    ?.infrastructure_development_internal_funding_upto_10_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.institutional_development
                                                ?.infrastructure_development_external_funding_upto_5_lakhs?.total_activity *
                                                count?.institutional_development
                                                    ?.infrastructure_development_external_funding_upto_5_lakhs?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            {/* <tr>
                                                        <td className="tablewidth">
                                                            c. Revenue generated through Training Programmes
                                                            as Co-ordinator/ Other Avenues
                                                        </td>
                                                        <td>
                                                            <tr>
                                                                <td>&lt; 3 lakhs</td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>3 - 5 lakhs</td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>&gt; 5 lakhs</td>
                                                            </tr>
                                                        </td>
                                                        <td>
                                                            <tr>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Enter Count"
                                                                        className="fieldinput"
                                                                        defaultValue={
                                                                            count?.institutional_development
                                                                                ?.revenue_generated_through_training_programmes_lt_3_lakhs ??
                                                                            0
                                                                        }
                                                                        onChange={(e) =>
                                                                            setData(
                                                                                e.target.value,
                                                                                "institutional_development",
                                                                                "revenue_generated_through_training_programmes_lt_3_lakhs"
                                                                            )
                                                                        }
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Enter Count"
                                                                        className="fieldinput"
                                                                        defaultValue={
                                                                            count?.institutional_development
                                                                                ?.revenue_generated_through_training_programmes_3_to_5_lakhs ??
                                                                            0
                                                                        }
                                                                        onChange={(e) =>
                                                                            setData(
                                                                                e.target.value,
                                                                                "institutional_development",
                                                                                "revenue_generated_through_training_programmes_3_to_5_lakhs"
                                                                            )
                                                                        }
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Enter Count"
                                                                        className="fieldinput"
                                                                        defaultValue={
                                                                            count?.institutional_development
                                                                                ?.revenue_generated_through_training_programmes_gt_5_lakhs ??
                                                                            0
                                                                        }
                                                                        onChange={(e) =>
                                                                            setData(
                                                                                e.target.value,
                                                                                "institutional_development",
                                                                                "revenue_generated_through_training_programmes_gt_5_lakhs"
                                                                            )
                                                                        }
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </td>
                                                        <td>
                                                            <tr>
                                                                <td>
                                                                    {
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_lt_3_lakhs?.per_actitity_score || '-'
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>
                                                                    {
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_3_to_5_lakhs?.per_actitity_score || '-'
                                                                    }
                                                                </td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>
                                                                    {
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_gt_5_lakhs?.per_actitity_score || '-'
                                                                    }
                                                                </td>
                                                            </tr>
                                                        </td>
                                                        <td>
                                                            <tr>
                                                                <td>
                                                                    {count?.institutional_development
                                                                        ?.revenue_generated_through_training_programmes_lt_3_lakhs?.total_activity *
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_lt_3_lakhs?.per_actitity_score || '-'}
                                                                </td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>
                                                                    {count?.institutional_development
                                                                        ?.revenue_generated_through_training_programmes_3_to_5_lakhs?.total_activity *
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_3_to_5_lakhs?.per_actitity_score || '-'}
                                                                </td>
                                                            </tr>
                                                            <br />
                                                            <tr>
                                                                <td>
                                                                    {count?.institutional_development
                                                                        ?.revenue_generated_through_training_programmes_gt_5_lakhs?.total_activity *
                                                                        count?.institutional_development
                                                                            ?.revenue_generated_through_training_programmes_gt_5_lakhs?.per_actitity_score || '-'}
                                                                </td>
                                                            </tr>
                                                        </td>
                                                    </tr>?.total_activity */}
                            <tr>
                                <td className="tablewidth">
                                    c. Research/ academic events (workshop/
                                    conference/ seminar/ webinar/ programmes under
                                    national initiatives) organized at national/
                                    international level as Coordinator (Score for the
                                    webinar will be 20% of workshop/ conference/
                                    seminar; Score for the Co-coordinator of workshop/
                                    conference/ seminar will be 50%)
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            International/ Programmes under national
                                            initiatives
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>National</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.research_or_academic_events_international?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.research_or_academic_events_national?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.research_or_academic_events_international?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.research_or_academic_events_national?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.institutional_development
                                                ?.research_or_academic_events_international?.total_activity *
                                                count?.institutional_development
                                                    ?.research_or_academic_events_international?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.institutional_development
                                                ?.research_or_academic_events_national?.total_activity *
                                                count?.institutional_development
                                                    ?.research_or_academic_events_national?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    d. Events conducted in collaboration with Industry
                                </td>
                                <td>
                                    <tr>
                                        <td>With Revenue Generation</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Without Revenue Generation</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.events_conducted_with_revenue_generation?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.events_conducted_without_revenue_generation?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.events_conducted_with_revenue_generation?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.events_conducted_without_revenue_generation?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.institutional_development
                                                ?.events_conducted_with_revenue_generation?.total_activity *
                                                count?.institutional_development
                                                    ?.events_conducted_with_revenue_generation?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.institutional_development
                                                ?.events_conducted_without_revenue_generation?.total_activity *
                                                count?.institutional_development
                                                    ?.events_conducted_without_revenue_generation?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    e. New initiatives implemented for the Institute
                                    Development:
                                </td>
                                <td>
                                    <tr>
                                        <td>With Revenue Generation</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Without Revenue Generation</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.new_initiatives_implemented_with_revenue_generation?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.new_initiatives_implemented_without_revenue_generation?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.new_initiatives_implemented_with_revenue_generation?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.institutional_development
                                                    ?.new_initiatives_implemented_without_revenue_generation?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.institutional_development
                                                ?.new_initiatives_implemented_with_revenue_generation?.total_activity *
                                                count?.institutional_development
                                                    ?.new_initiatives_implemented_with_revenue_generation?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.institutional_development
                                                ?.new_initiatives_implemented_without_revenue_generation?.total_activity *
                                                count?.institutional_development
                                                    ?.new_initiatives_implemented_without_revenue_generation?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">Total</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    {count?.institutional_development
                                        ?.administrative_contributions_hod_of_the_committee?.total_activity *
                                        count?.institutional_development
                                            ?.administrative_contributions_hod_of_the_committee?.per_actitity_score +
                                        count?.institutional_development
                                            ?.administrative_contributions_member_of_the_committee?.total_activity *
                                        count?.institutional_development
                                            ?.administrative_contributions_member_of_the_committee?.per_actitity_score +
                                        count?.institutional_development
                                            ?.infrastructure_development_internal_funding_upto_10_lakhs?.total_activity *
                                        count?.institutional_development
                                            ?.infrastructure_development_internal_funding_upto_10_lakhs?.per_actitity_score +
                                        count?.institutional_development
                                            ?.infrastructure_development_external_funding_upto_5_lakhs?.total_activity *
                                        count?.institutional_development
                                            ?.infrastructure_development_external_funding_upto_5_lakhs?.per_actitity_score
                                        +
                                        // count?.institutional_development
                                        //     ?.revenue_generated_through_training_programmes_lt_3_lakhs?.total_activity *
                                        // count?.institutional_development
                                        //     ?.revenue_generated_through_training_programmes_lt_3_lakhs?.per_actitity_score +
                                        // count?.institutional_development
                                        //     ?.revenue_generated_through_training_programmes_3_to_5_lakhs?.total_activity *
                                        // count?.institutional_development
                                        //     ?.revenue_generated_through_training_programmes_3_to_5_lakhs?.per_actitity_score +
                                        // count?.institutional_development
                                        //     ?.revenue_generated_through_training_programmes_gt_5_lakhs?.total_activity *
                                        // count?.institutional_development
                                        //     ?.revenue_generated_through_training_programmes_gt_5_lakhs?.per_actitity_score
                                        +
                                        count?.institutional_development
                                            ?.research_or_academic_events_international?.total_activity *
                                        count?.institutional_development
                                            ?.research_or_academic_events_international?.per_actitity_score +
                                        count?.institutional_development
                                            ?.research_or_academic_events_national?.total_activity *
                                        count?.institutional_development
                                            ?.research_or_academic_events_national?.per_actitity_score +
                                        count?.institutional_development
                                            ?.events_conducted_with_revenue_generation?.total_activity *
                                        count?.institutional_development
                                            ?.events_conducted_with_revenue_generation?.per_actitity_score +
                                        count?.institutional_development
                                            ?.events_conducted_without_revenue_generation?.total_activity *
                                        count?.institutional_development
                                            ?.events_conducted_without_revenue_generation?.per_actitity_score +
                                        count?.institutional_development
                                            ?.new_initiatives_implemented_with_revenue_generation?.total_activity *
                                        count?.institutional_development
                                            ?.new_initiatives_implemented_with_revenue_generation?.per_actitity_score +
                                        count?.institutional_development
                                            ?.new_initiatives_implemented_without_revenue_generation?.total_activity *
                                        count?.institutional_development
                                            ?.new_initiatives_implemented_without_revenue_generation?.per_actitity_score}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )}
            {active === 3 && (
                <>
                    <h5 className="centertext my-5">
                        PROFESSIONAL CONTRIBUTIONS
                    </h5>
                    <table className="tablereport table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Topic</th>
                                <th scope="col">Criteria</th>
                                <th scope="col">Target Fixed	</th>
                                <th scope="col">Score/Item	</th>
                                <th scope="col">Score Fixed</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="tablewidth">
                                    a. Resource person in Training Programmes/
                                    Workshops (External)
                                </td>
                                <td>
                                    <tr>
                                        <td>For 12 hours</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.resource_person_in_training_programmes?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.resource_person_in_training_programmes?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.resource_person_in_training_programmes?.total_activity *
                                                count?.professional_contributions
                                                    ?.resource_person_in_training_programmes?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    b. Training programmes attended
                                </td>
                                <td>
                                    <tr>
                                        <td>International</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>National</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.training_programmes_attended_international?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.training_programmes_attended_national?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.training_programmes_attended_international?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.training_programmes_attended_national?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.training_programmes_attended_international?.total_activity *
                                                count?.professional_contributions
                                                    ?.training_programmes_attended_international?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.training_programmes_attended_national?.total_activity *
                                                count?.professional_contributions
                                                    ?.training_programmes_attended_national?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    c. Participation and academic contributions in the
                                    area of your academic and professional expertise
                                    at International/ National/ State Level
                                </td>
                                <td>
                                    <tr>
                                        <td>International</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>National</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>State</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_academic_contributions_international?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_academic_contributions_national?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_academic_contributions_state?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_academic_contributions_international?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_academic_contributions_national?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_academic_contributions_state?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.participation_and_academic_contributions_international?.total_activity *
                                                count?.professional_contributions
                                                    ?.participation_and_academic_contributions_international?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.participation_and_academic_contributions_national?.total_activity *
                                                count?.professional_contributions
                                                    ?.participation_and_academic_contributions_national?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.participation_and_academic_contributions_state?.total_activity *
                                                count?.professional_contributions
                                                    ?.participation_and_academic_contributions_state?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    d. Overseas visited for Academic Events/ Plenary
                                    Lectures/ Invited Talks/ Part of Delegation/
                                    Others
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            academic events/ plenary lectures/ invited
                                            talks/
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Part of delegation</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.overseas_visited_for_academic_events?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.overseas_visited_for_part_of_delegation?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.overseas_visited_for_academic_events?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.overseas_visited_for_part_of_delegation?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.overseas_visited_for_academic_events?.total_activity *
                                                count?.professional_contributions
                                                    ?.overseas_visited_for_academic_events?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.overseas_visited_for_part_of_delegation?.total_activity *
                                                count?.professional_contributions
                                                    ?.overseas_visited_for_part_of_delegation?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    e. Participation and contributions in the area of
                                    your academic and professional expertise
                                </td>
                                <td>
                                    <tr>
                                        <td>PG Examiner</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Doctoral Committee member</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Ph.D. Examiner</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_contributions_in_pg_examiner?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_contributions_in_doctoral_committee?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_contributions_in_phd_examiner?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_contributions_in_pg_examiner?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_contributions_in_doctoral_committee?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.participation_and_contributions_in_phd_examiner?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.participation_and_contributions_in_pg_examiner?.total_activity *
                                                count?.professional_contributions
                                                    ?.participation_and_contributions_in_pg_examiner?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.participation_and_contributions_in_doctoral_committee?.total_activity *
                                                count?.professional_contributions
                                                    ?.participation_and_contributions_in_doctoral_committee?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.participation_and_contributions_in_phd_examiner?.total_activity *
                                                count?.professional_contributions
                                                    ?.participation_and_contributions_in_phd_examiner?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    f. Editor-in-Chief/ Editorial Board Member/ Peer
                                    Reviewer/ Others
                                </td>
                                <td>
                                    <tr>
                                        <td>Editor-in-chief (SCI)</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Editor-in-chief (Scopus)</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Editorial board member (SCI)</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Editorial board member (Scopus)</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Peer reviewer (SCI)</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Peer reviewer (Scopus)</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.editor_in_cheif_sci?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.editor_in_cheif_scopus?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.editorial_board_member_sci?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.editorial_board_member_scopus?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.peer_reviewer_sci?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.peer_reviewer_scopus?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.editor_in_cheif_sci?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.editor_in_cheif_scopus?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.editorial_board_member_sci?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.editorial_board_member_scopus?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.peer_reviewer_sci?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.peer_reviewer_scopus?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>

                                <td>
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.editor_in_cheif_sci?.total_activity *
                                                count?.professional_contributions
                                                    ?.editor_in_cheif_sci?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.editor_in_cheif_scopus?.total_activity *
                                                count?.professional_contributions
                                                    ?.editor_in_cheif_scopus?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.editorial_board_member_sci?.total_activity *
                                                count?.professional_contributions
                                                    ?.editorial_board_member_sci?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.editorial_board_member_scopus?.total_activity *
                                                count?.professional_contributions
                                                    ?.editorial_board_member_scopus?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.peer_reviewer_sci?.total_activity *
                                                count?.professional_contributions
                                                    ?.peer_reviewer_sci?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.peer_reviewer_scopus?.total_activity *
                                                count?.professional_contributions
                                                    ?.peer_reviewer_scopus?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    g. National/ International academic assignment for
                                    more than 1 year (Full-time)
                                </td>
                                <td>
                                    <tr>
                                        <td>International</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>National</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.international_academic_assignment?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.national_academic_assignment?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.international_academic_assignment?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.national_academic_assignment?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.international_academic_assignment?.total_activity *
                                                count?.professional_contributions
                                                    ?.international_academic_assignment?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.national_academic_assignment?.total_activity *
                                                count?.professional_contributions
                                                    ?.national_academic_assignment?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">
                                    h. Fellow/ Life Member/ Member of Professional
                                    Bodies/ Societies
                                </td>
                                <td>
                                    <tr>
                                        <td>Fellow</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Life member</td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>Member</td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.professional_contributions?.fellow?.total_activity || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.life_member?.total_activity || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions?.member?.total_activity || '-'}
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.professional_contributions?.fellow?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {
                                                count?.professional_contributions
                                                    ?.life_member?.per_actitity_score || '-'
                                            }
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions?.member?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>
                                            {count?.professional_contributions?.fellow?.total_activity *
                                                count?.professional_contributions?.fellow?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions
                                                ?.life_member?.total_activity *
                                                count?.professional_contributions
                                                    ?.life_member?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td>
                                            {count?.professional_contributions?.member?.total_activity *
                                                count?.professional_contributions?.member?.per_actitity_score || '-'}
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td className="tablewidth">Total</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    {count?.professional_contributions
                                        ?.resource_person_in_training_programmes?.total_activity *
                                        count?.professional_contributions
                                            ?.resource_person_in_training_programmes?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.training_programmes_attended_international?.total_activity *
                                        count?.professional_contributions
                                            ?.training_programmes_attended_international?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.training_programmes_attended_national?.total_activity *
                                        count?.professional_contributions
                                            ?.training_programmes_attended_national?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.participation_and_academic_contributions_international?.total_activity *
                                        count?.professional_contributions
                                            ?.participation_and_academic_contributions_international?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.participation_and_academic_contributions_national?.total_activity *
                                        count?.professional_contributions
                                            ?.participation_and_academic_contributions_national?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.participation_and_academic_contributions_state?.total_activity *
                                        count?.professional_contributions
                                            ?.participation_and_academic_contributions_state?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.overseas_visited_for_academic_events?.total_activity *
                                        count?.professional_contributions
                                            ?.overseas_visited_for_academic_events?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.overseas_visited_for_part_of_delegation?.total_activity *
                                        count?.professional_contributions
                                            ?.overseas_visited_for_part_of_delegation?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.participation_and_contributions_in_pg_examiner?.total_activity *
                                        count?.professional_contributions
                                            ?.participation_and_contributions_in_pg_examiner?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.participation_and_contributions_in_doctoral_committee?.total_activity *
                                        count?.professional_contributions
                                            ?.participation_and_contributions_in_doctoral_committee?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.participation_and_contributions_in_phd_examiner?.total_activity *
                                        count?.professional_contributions
                                            ?.participation_and_contributions_in_phd_examiner?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.editor_in_cheif_sci?.total_activity *
                                        count?.professional_contributions
                                            ?.editor_in_cheif_sci?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.editor_in_cheif_scopus?.total_activity *
                                        count?.professional_contributions
                                            ?.editor_in_cheif_scopus?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.editorial_board_member_sci?.total_activity *
                                        count?.professional_contributions
                                            ?.editorial_board_member_sci?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.editorial_board_member_scopus?.total_activity *
                                        count?.professional_contributions
                                            ?.editorial_board_member_scopus?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.peer_reviewer_sci?.total_activity *
                                        count?.professional_contributions
                                            ?.peer_reviewer_sci?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.peer_reviewer_scopus?.total_activity *
                                        count?.professional_contributions
                                            ?.peer_reviewer_scopus?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.international_academic_assignment?.total_activity *
                                        count?.professional_contributions
                                            ?.international_academic_assignment?.per_actitity_score +
                                        count?.professional_contributions
                                            ?.national_academic_assignment?.total_activity *
                                        count?.professional_contributions
                                            ?.national_academic_assignment?.per_actitity_score +
                                        count?.professional_contributions?.fellow?.total_activity *
                                        count?.professional_contributions?.fellow?.per_actitity_score +
                                        count?.professional_contributions?.life_member?.total_activity *
                                        count?.professional_contributions
                                            ?.life_member?.per_actitity_score +
                                        count?.professional_contributions?.member?.total_activity *
                                        count?.professional_contributions?.member?.per_actitity_score}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )}
        </div>
    )
}

export default SubmittedPerformanceIndex